:root {
  /* 'EmojiMart' represents the general emoji font of the app, themes may redefine it */
  --emojifonts: "EmojiMart", "Apple Color Emoji", NotoEmoji;
  --fonts-default:
    Roboto, var(--emojifonts), "Helvetica Neue", Arial, Helvetica, NotoMono,
    sans-serif;
  --fonts-system: system-ui, var(--fonts-default);
}

/* Theming Colors */
.appPickerContainer {
  position: absolute;
  z-index: 10;
  width: 56%;
  max-width: 640px;
  height: 70vh;
  margin-inline-start: 8px;
  bottom: 50px;
  background-color: var(--bgPrimary);
  border-radius: var(--picker-BorderRadius);
  overflow: hidden;
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.0901960784);
}
@media (max-width: 900px) {
  .appPickerContainer {
    width: 50%;
  }
}
@media (max-width: 720px) {
  .appPickerContainer {
    width: calc(100% - 18px);
    min-width: 300px;
  }
}

.appPicker {
  position: relative;
}

.appPickerList {
  flex-wrap: wrap;
  gap: 6px;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(70vh - 70px);
  padding: 8px 0 32px 8px;
}

.appListItem {
  width: 300px;
  height: 76px;
  border-radius: 8px;
  cursor: pointer;
  background: none;
  border: none;
  color: var(--picker-text-rgb);
  text-align: left;
  outline: none;
}
.appListItem:hover, .appListItem:focus {
  background-color: var(--picker-border-and-hover-color);
}

.appItem {
  display: flex;
  align-items: center;
  color: var(--picker-text-rgb);
  text-align: left;
}

.searchInput {
  color: var(--picker-text-rgb);
  width: 100%;
  padding: 10px;
  background: var(--bgPrimary);
  border: none;
  border-bottom: 1px solid var(--picker-border-and-hover-color);
  font-size: 14px;
}
.searchInput:focus, .searchInput:active {
  outline: none;
}

.searchInputButton {
  position: absolute;
  top: 2px;
  right: 0;
}
.searchInputButton.searchInputButton {
  color: var(--picker-text-rgb);
}

.appIcon {
  width: 64px;
  height: 64px;
  margin-inline-end: 16px;
  border-radius: 5px;
}

.appInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.appInfo p {
  margin: 2px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.appInfo button {
  border: none;
  background: none;
  color: var(--globalLinkColor);
  text-align: left;
  margin: 2px 0;
  padding: 0;
}

/** limited width in app picker */
.appListItem .appInfo {
  width: 208px;
}

.appDetails p {
  margin: 8px 0;
}
.appDetails p span {
  font-weight: bold;
}

.appDescription {
  margin: 12px 0;
  line-height: 20px;
}

.appDownloadingStatus {
  min-width: 100px;
  padding: 8px 12px;
  margin: 10px 0;
}

.appName {
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.appAuthor {
  color: #808080;
}

.tabBar {
  position: sticky;
  bottom: 0px;
  display: flex;
  width: 100%;
  background: var(--bgPrimary);
  border-top: 1px solid var(--picker-border-and-hover-color);
}
.tabBar button {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--picker-text-rgb);
  flex-grow: 1;
  padding: 8px;
  border: none;
  border-right: 1px solid var(--picker-border-and-hover-color);
  background: var(--bgPrimary);
  cursor: pointer;
}
.tabBar button.activeTab {
  font-weight: bold;
  background-color: var(--picker-border-and-hover-color);
}
.tabBar button:last-child {
  border-right: none;
}
.tabBar button:hover {
  background-color: var(--picker-border-and-hover-color);
}

.category {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.categoryIcon {
  width: 36px;
  height: 36px;
  margin: auto;
}

.categoryTitle {
  padding: 6px 0;
}

/**
should style the svg icons but doesn't?

.category-icon {
  width: 24px;
  height: 24px;
}

.icon-path {
  fill: #999;
}
*/